module.exports = __webpack_public_path__ + "img/correo.3ec32885.png";